/**
 * Frontend helper to call the NestJS backend Places proxy routes.
 * Routes: POST /api/v1/places/autocomplete and POST /api/v1/places/details
 */

import { API_CONFIG } from '@/config/api.config';

const BASE_URL = API_CONFIG.baseURL;

async function postPlaces(url: string, body: unknown): Promise<Response> {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export interface PlacesPrediction {
  place_id: string;
  description: string;
  structured_formatting?: {
    main_text: string;
    secondary_text: string;
  };
}

export async function placesAutocomplete(params: {
  input: string;
  types?: string;
  language?: string;
  components?: string;
}): Promise<{ predictions: PlacesPrediction[] }> {
  try {
    const res = await postPlaces(`${BASE_URL}/places/autocomplete`, params);
    if (res.ok) return res.json();
  } catch (error) {
    console.error('Places autocomplete failed:', error);
  }
  return { predictions: [] };
}

export async function placesDetails(params: {
  placeId: string;
  language?: string;
}): Promise<any> {
  try {
    const res = await postPlaces(`${BASE_URL}/places/details`, params);
    if (res.ok) return res.json();
  } catch (error) {
    console.error('Places details failed:', error);
  }
  return {};
}